module.exports = __webpack_public_path__ + "static/media/3.c7e0eef6.png";